export const blockIconsFileAttachEmail = (
	<span className='material-symbols-outlined'>attach_email</span>
);
